(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/handlers/draw-handlers.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/handlers/draw-handlers.js');
"use strict";


const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const _ref = svs.isServer ? require('../proxy-handler.es6') : svs.components.lbUtils.apiProxy,
  http = _ref.http;
const featureToggle = svs.isServer ? require('../feature-toggle.es6') : svs.components.lbUtils.apiProxy.featureToggle;
const _ref2 = svs.isServer ? require('../constants.es6') : svs.components.lbUtils.apiProxy.constants,
  FEATURE_TOGGLE = _ref2.FEATURE_TOGGLE;
const _ref3 = svs.isServer ? trinidad.components.require('utils', 'products') : svs.utils.products,
  getDrawName = _ref3.getDrawName;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const logger = getLogger('lb-utils:api-proxy:draw-handlers');
const DrawURLPatterns = {
  DRAW_SUMMARY: '/draw/1/:product/draws/:drawNumber/light',
  DRAWS_SUMMARY: '/draw/1/:product/draws/light',
  DRAW: '/draw/1/:product/draws/:drawNumber',
  DRAWS: '/draw/1/:product/draws'
};
const DrawCloudEndpointTemplates = {
  DRAW_SUMMARY: '/v1/:product/draws/:drawNumber/summary',
  DRAWS_SUMMARY: '/v1/:product/draws/summary',
  DRAW: '/v1/:product/draws/:drawNumber',
  DRAWS: '/v1/:product/draws'
};
const SPECIAL_VALID_PRODUCTS = new Set(['topptipsetfamily']);
const isValidDrawNumber = drawNumber => /^\d+$/.test(String(drawNumber !== null && drawNumber !== void 0 ? drawNumber : ''));
const isValidProduct = product => SPECIAL_VALID_PRODUCTS.has(product) || Boolean(getDrawName(product));

const noTransformResolver = async _ref4 => {
  let data = _ref4.data;
  return data;
};

const validator = _ref5 => {
  let drawNumber = _ref5.drawNumber,
    product = _ref5.product;
  return isValidDrawNumber(drawNumber) && isValidProduct(product);
};
const bombenDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['bomben'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_BOMBEN_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['bomben'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_BOMBEN_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['bomben'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_BOMBEN_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['bomben'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_BOMBEN_DRAWS_CLOUD_API, options)
  }
})];
const europatipsetDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['europatipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_EUROPATIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['europatipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_EUROPATIPSET_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['europatipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_EUROPATIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['europatipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_EUROPATIPSET_DRAWS_CLOUD_API, options)
  }
})];
const powerplayDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['powerplay'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_POWERPLAY_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['powerplay'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_POWERPLAY_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['powerplay'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_POWERPLAY_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['powerplay'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_POWERPLAY_DRAWS_CLOUD_API, options)
  }
})];
const stryktipsetDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['stryktipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_STRYKTIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['stryktipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_STRYKTIPSET_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['stryktipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_STRYKTIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['stryktipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_STRYKTIPSET_DRAWS_CLOUD_API, options)
  }
})];
const topptipsetDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['topptipset', 'topptipsetextra', 'topptipsetstryk'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['topptipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['topptipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['topptipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API, options)
  }
})];
const topptipsetFamilyDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['topptipsetfamily'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['topptipsetfamily'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['topptipsetfamily'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['topptipsetfamily'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_TOPPTIPSET_DRAWS_CLOUD_API, options)
  }
})];
const challengeDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['challenge'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_CHALLENGE_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['challenge'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_CHALLENGE_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['challenge'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_CHALLENGE_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['challenge'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_CHALLENGE_DRAWS_CLOUD_API, options)
  }
})];
const maltipsetDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['maltipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MALTIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['maltipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MALTIPSET_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['maltipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MALTIPSET_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['maltipset'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MALTIPSET_DRAWS_CLOUD_API, options)
  }
})];
const matchenDrawHandlers = [http.get("".concat(DrawURLPatterns.DRAW_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['matchen'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MATCHEN_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS_SUMMARY, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['matchen'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS_SUMMARY,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MATCHEN_DRAWS_CLOUD_API, options)
  }
}), http.get("".concat(DrawURLPatterns.DRAW, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['matchen'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAW,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MATCHEN_DRAWS_CLOUD_API, options),
    validate: validator
  }
}), http.get("".concat(DrawURLPatterns.DRAWS, "?include=:include"), noTransformResolver, {
  config: {
    allowedProducts: ['matchen'],
    cloudEndpointTemplate: DrawCloudEndpointTemplates.DRAWS,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MATCHEN_DRAWS_CLOUD_API, options)
  }
})];
const drawHandlers = [...bombenDrawHandlers, ...challengeDrawHandlers, ...europatipsetDrawHandlers, ...maltipsetDrawHandlers, ...matchenDrawHandlers, ...powerplayDrawHandlers, ...stryktipsetDrawHandlers, ...topptipsetDrawHandlers, ...topptipsetFamilyDrawHandlers];
if (svs.isServer) {
  module.exports = drawHandlers;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.handlers.drawHandlers', drawHandlers);
}

 })(window);